export default __webpack_public_path__ + "static/media/dreamstime_s_119442663.f0297600.jpg";